const SENSITIVE_KEY =
  /(?:^|_)(password|passwd|secret|token|commercial[_-]?key|activation[_-]?key|authorization|api[_-]?key|private[_-]?key|certificate|certificat)(?:$|_)/i;
const EMAIL_PATTERN = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
const NXS_KEY_PATTERN = /\bNXS-[A-Z0-9]{4}(?:-[A-Z0-9]{4}){3}\b/gi;

function maskString(value: string): string {
  return value.replace(EMAIL_PATTERN, '[email]').replace(NXS_KEY_PATTERN, '[licence-key]');
}

function scrubValue(value: unknown, depth = 0): unknown {
  if (depth > 6) return '[truncated]';
  if (value == null || typeof value === 'boolean' || typeof value === 'number') return value;
  if (typeof value === 'string') return maskString(value);
  if (Array.isArray(value)) return value.map((v) => scrubValue(v, depth + 1));
  if (typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(obj)) {
      if (SENSITIVE_KEY.test(k)) {
        out[k] = '[redacted]';
      } else {
        out[k] = scrubValue(v, depth + 1);
      }
    }
    return out;
  }
  return String(value);
}

/** Retire PII et secrets avant écriture dans les logs. */
export function scrubLogPayload(payload: Record<string, unknown>): Record<string, unknown> {
  return scrubValue(payload) as Record<string, unknown>;
}
